/* ==========================================================
   DA LUCA V3.45 — Nylon / Perlon cleanup
   - removes generic leather six-card injection on textile PDPs
   - restores each Nylon/Perlon product's own six construction images
   - removes redundant textile story/material panels
   - removes textile review-intro spacer while keeping Judge.me reviews
   ========================================================== */
(function () {
  'use strict';

  function root() {
    return document.querySelector('.daluca-pdp');
  }

  function isTextilePage() {
    var r = root();
    return !!(r && (r.dataset.dalucaTextileSport === 'true' || r.classList.contains('daluca-pdp--textile-sport')));
  }

  function imageUrl(img) {
    if (!img) return '';
    return img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src') || '';
  }

  function uniqueCalloutImages(source) {
    if (!source) return [];
    var seen = new Set();
    var images = Array.prototype.slice.call(source.querySelectorAll('.product-callouts img'));
    return images.filter(function (img) {
      var url = imageUrl(img) || img.getAttribute('srcset') || img.getAttribute('data-srcset') || '';
      if (!url || seen.has(url)) return false;
      seen.add(url);
      return true;
    });
  }

  function cloneImage(original) {
    var img = document.createElement('img');
    var src = imageUrl(original);
    var srcset = original.getAttribute('srcset') || original.getAttribute('data-srcset') || '';
    var sizes = original.getAttribute('sizes') || '';
    if (src) img.src = src;
    if (srcset) img.srcset = srcset;
    if (sizes) img.sizes = sizes;
    img.alt = original.getAttribute('alt') || 'Da Luca textile watch strap construction detail';
    img.loading = 'lazy';
    img.decoding = 'async';
    return img;
  }

  function removeGenericSix() {
    document.querySelectorAll('.daluca-v99-live-six, .daluca-nylon-six-v345, .daluca-textile-six-v346').forEach(function (node) {
      node.remove();
    });
  }

  function buildTextileSix() {
    if (!isTextilePage()) return;
    if (document.querySelector('.daluca-textile-six-v346')) return;

    var source = document.querySelector('.daluca-product-details__description--sourceonly[data-daluca-description], .daluca-product-details--textile-sport [data-daluca-description]');
    var images = uniqueCalloutImages(source);
    if (images.length < 6) return;

    var section = document.createElement('section');
    section.className = 'daluca-textile-six-v346';
    var localized = window.DaLucaI18n && !/^en(?:-|$)/i.test(window.DaLucaI18n.locale || 'en');
    section.setAttribute('aria-label', localized ? window.DaLucaI18n.t('daluca_textile_features.section_label') : 'Textile strap construction details');

    var grid = document.createElement('div');
    grid.className = 'daluca-textile-six-v346__grid';

    images.slice(0, 6).forEach(function (original, index) {
      var item = document.createElement('figure');
      item.className = 'daluca-textile-six-v346__item ' + (index < 3 ? 'daluca-textile-six-v346__item--photo' : 'daluca-textile-six-v346__item--icon');
      if (localized) {
        var art = document.createElement('div');
        art.className = 'daluca-textile-six-v346__localized-art';
        art.style.cssText = 'position:relative!important;width:100%!important;height:0!important;padding-bottom:65%!important;overflow:hidden!important;border-radius:12px;';
        var image = cloneImage(original);
        image.alt = '';
        image.setAttribute('aria-hidden', 'true');
        image.style.cssText = 'position:absolute!important;top:0!important;left:0!important;width:100%!important;height:auto!important;max-width:none!important;max-height:none!important;aspect-ratio:auto!important;object-fit:fill!important;margin:0!important;';
        art.appendChild(image);
        var caption = document.createElement('figcaption');
        caption.className = 'daluca-textile-six-v346__localized-copy';
        caption.style.cssText = 'padding:16px 12px 18px!important;text-align:center!important;';
        var title = document.createElement('strong');
        var body = document.createElement('span');
        title.style.cssText = 'display:block!important;font-size:14px!important;line-height:1.4!important;color:var(--color-body, #203746)!important;';
        body.style.cssText = 'display:block!important;margin-top:5px!important;font-size:13px!important;line-height:1.5!important;';
        var titleKeys = ['material_title', (root().dataset.dalucaAppleStandard === 'true' || /(?:two[- ]piece|2[- ]piece)/i.test(root().dataset.handle || location.pathname)) ? 'two_piece_title' : 'one_piece_title', 'comfort_title', 'weaving_title', 'hardware_title', 'fit_title'];
        var bodyKeys = ['material_body', 'design_body', 'comfort_body', 'weaving_body', 'hardware_body', 'fit_body'];
        title.textContent = window.DaLucaI18n.t('daluca_textile_features.' + titleKeys[index]);
        body.textContent = window.DaLucaI18n.t('daluca_textile_features.' + bodyKeys[index]);
        caption.appendChild(title);
        caption.appendChild(body);
        item.classList.add('daluca-textile-six-v346__item--localized');
        item.style.cssText = 'display:block!important;height:auto!important;max-height:none!important;min-height:0!important;overflow:hidden!important;';
        item.appendChild(art);
        item.appendChild(caption);
      } else {
        item.appendChild(cloneImage(original));
      }
      grid.appendChild(item);
    });

    section.appendChild(grid);

    var details = document.querySelector('.daluca-product-details--textile-sport');
    if (details && details.parentNode) {
      details.parentNode.insertBefore(section, details.nextSibling);
      return;
    }

    var rec = document.querySelector('product-recommendations');
    var recSection = rec && rec.closest('.shopify-section');
    if (recSection && recSection.parentNode) recSection.parentNode.insertBefore(section, recSection);
  }

  function removeRedundantTextilePanels() {
    document.querySelectorAll('.daluca-textile-story, .daluca-textile-details').forEach(function (node) {
      node.remove();
    });
  }

  function tightenReviews() {
    if (!isTextilePage()) return;
    document.body.classList.add('daluca-textile-page-v345');

    var intro = document.querySelector('.daluca-review-intro');
    if (!intro) return;

    var holder = intro.closest('.shopify-section') || intro.closest('.section-custom-liquid') || intro.parentElement;
    var anchor = holder ? holder.querySelector('#daluca-reviews') : document.querySelector('#daluca-reviews');
    var next = holder ? holder.nextElementSibling : null;
    var holderHasReviewWidget = !!(holder && holder.querySelector && holder.querySelector('.jdgm-rev-widg, .jdgm-widget, .jdgm-review-widget, #shopify-product-reviews'));

    /* V3.98: once the shared review intro has been merged into the real Judge.me
       app section, NEVER hide that holder. The older cleanup routine used to hide
       the whole app section on a later pass, which made the top review count jump
       to an empty spot even though the product had reviews. */
    if (holderHasReviewWidget) {
      holder.style.removeProperty('display');
      holder.style.removeProperty('visibility');
      holder.style.setProperty('margin-top', '0', 'important');
      holder.style.setProperty('padding-top', '0', 'important');
      holder.classList.add('daluca-textile-review-section-v345');
      return;
    }

    if (anchor && holder && holder.parentNode) {
      holder.parentNode.insertBefore(anchor, next || holder.nextSibling);
    }

    if (holder) {
      holder.style.setProperty('display', 'none', 'important');
      holder.style.setProperty('margin', '0', 'important');
      holder.style.setProperty('padding', '0', 'important');
      holder.style.setProperty('min-height', '0', 'important');
    }

    if (next && next.classList && next.classList.contains('section-app-wrapper')) {
      next.classList.add('daluca-textile-review-section-v345');
      var wrapper = next.querySelector('.app-wrapper');
      if (wrapper) {
        wrapper.style.setProperty('padding-top', '10px', 'important');
        wrapper.style.setProperty('margin-top', '0', 'important');
      }
    }
  }

  function cleanup() {
    if (!isTextilePage()) return;
    removeGenericSix();
    removeRedundantTextilePanels();
    buildTextileSix();
    tightenReviews();
  }

  function schedule() {
    cleanup();
    [80, 250, 700, 1500, 3000].forEach(function (delay) {
      window.setTimeout(cleanup, delay);
    });

    var timer = null;
    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
          return node.nodeType === 1 && (
            (node.matches && node.matches('.daluca-v99-live-six, .daluca-review-intro, .jdgm-widget, .jdgm-review-widget, .product-callouts')) ||
            (node.querySelector && node.querySelector('.daluca-v99-live-six, .daluca-review-intro, .jdgm-widget, .jdgm-review-widget, .product-callouts'))
          );
        });
      });
      if (!relevant) return;
      window.clearTimeout(timer);
      timer = window.setTimeout(cleanup, 30);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
})();
